import React from "react";

const AuthumSchoolSearchForm = ({
  student,
  setStudent,
  searchStudents,
  resetSearch
}) => {
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchStudents(e);
  };

  
const handleStudentChange = (e) => {
    const value = e.target.value;
    setStudent(value);
    if (value === '') {
      resetSearch(e);
    }
};

  return (
    <form className="mg-t-20" onSubmit={handleSearchSubmit}>
      <div className="row gutters-8">
        <div className="col-9-xxxl col-xl-6 col-lg-12 col-12 form-group">
          <div className="row">
            
          <div className="col-lg-12 mt-2">
            <label htmlFor="">Student Name(s):</label>
              <input
                type="text"
                placeholder="Enter first or last name of student..."
                style={{ border: "1px solid grey" }}
                value={student}
                onChange={handleStudentChange}
                className="form-control"
              />
            </div>
            
          </div>
        </div>

        <div className="col-3-xxxl col-xl-6 col-lg-12 col-12 mt-4 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue mt-4 ml-2"
          >
            SEARCH
          </button>
        </div>
      </div>
    </form>
  );
};

export default AuthumSchoolSearchForm;